export default {
  status: "open",
  title: "",
  geolocations: [],
  description: "",
  positions: 1,
  jobType: "fulltime",
  jobPayment: "effective",
  languages: [],
  professions: [],
  educationLevelsAdvanced: [],
  skillsReq: [],
  questionsAdvanced: [],
  steps: []
};
